// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r-Z5","colBig":"styles_colBig__3b8Zw","colSmall":"styles_colSmall__1Qtvf","shopifyNameWrapper":"styles_shopifyNameWrapper__3S5Xr"};